const STATE = {
  user: {},
  currentUserAdpPermission: {
    data: {},
    loaded: false,
  },
  adGroups: {
    loading: false,
    data: [],
  },
  users: {
    loading: false,
    data: [],
  },
  groups: {
    loading: false,
    data: [],
  },
  configuredUsers: {
    loading: false,
    data: [],
  },
  usersPermissions: null,
};

export default STATE;
